import { css, keyframes } from '@emotion/core';

/* Variables */

// FONTS
export const fontYugo =
  '"游ゴシック体", YuGothic, "游ゴシック", "Yu Gothic", "メイリオ", sans-serif';
export const fontEn = '"Alata", sans-serif';
export const fontHiraginoKakugo = '"ヒラギノ角ゴシック", "Hiragino Sans" ,sans-serif';

// COLORS
export const black01 = '#303030';
export const black02 = '#4a4a4a';
export const black03 = '#636363';
export const green01 = '#00ab84';
export const green02 = '#ccdbd5';
export const white01 = '#f7fcfa';
export const gray01 = '#f6f6f6';
export const gray02 = '#d9d9d9';
export const gray03 = '#f0f0f0';
export const gray04 = '#a0a0a0';
export const red01 = '#ff684a';
export const grayBg = '#fafafa';
export const grayBorder = '#e5e5e5';

// EASING
export const easeinout = 'cubic-bezier(.63, .32, .35, .63)';
export const easeout = 'cubic-bezier(.4,.51,.29,.99)';
export const easeoutquart = 'cubic-bezier(0, 0.21, 0, 0.99)';
export const easein = 'cubic-bezier(.7, .11, .85, .28)';

// EASING
export const baseDurationTime = '0.4s';
export const fastDurationTime = '0.3s';
export const slowDurationTime = '0.5s';

// base
export const base = `
  html {
    -webkit-font-smoothing: antialiased;
  }

  img {
    vertical-align: bottom;
  }

  button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    outline: none;
    padding: 0;
    appearance: none;
  }

  p,
  h1,
  h2,
  h3,
  h4 {
    margin: 0;
    font-weight: normal;
  }

  ol,
  ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  sub,
  sup {
    font-size: 62.5%;
  }
  sub {
    bottom: -.05em;
  }
  sup {
    top: -.6em;
  }
  @media screen and (min-width: 768px), print {
    a:hover {
      color: inherit;
      text-decoration: none;
    }
  }
  .common-footer {
    @media screen and (min-width: 768px), print {
      a:hover {
        color: #4caadc;
        text-decoration: underline;
      }
    }
  }
  .slick-list {
    overflow: visible;
  }
  #global-header {
    .is-menu-open & {
      opacity: 0;
      pointer-events: none:
    }
  }
`;

/* mixin */
export const breakP = 768;
export const spMin = 375;
export const pcMax = 1440;
export const pcMin = 1064;
export const pcHeaderH = 69;
export const spHeaderH = 66;

export const contentWidth = 960;

export const mq = {
  pcMax: `@media (min-width: ${pcMax + 1}px)`,
  pc: `@media (min-width: ${breakP + 1}px)`,
  pcMin: `@media (max-width: ${pcMin}px) and (min-width: ${breakP + 1}px)`,
  sp: `@media (max-width: ${breakP}px)`,
  spMin: `@media (max-width: ${spMin - 1}px)`,
  ie: `@media all and (-ms-high-contrast: none)`,
};

export const text = (fontSize = '14px', lineHeight = 1) => {
  return `
    font-size: ${fontSize};
    line-height: ${lineHeight};
    margin-bottom: calc((${lineHeight} - 1) * ${fontSize} / 2 * -1);
    margin-top: calc((${lineHeight} - 1) * ${fontSize} / 2 * -1);
  `;
};

export const hoverFade = `
  transition: opacity ${baseDurationTime} ease;
  ${mq.pc} {
    &:hover {
      opacity: .6;
    }
  }
`;

export const lhCrop = lineHeight => {
  return `
    line-height: ${lineHeight};

    &::before {
      content: '';
      margin-top: calc((1 - ${lineHeight}) * .5em);
    }

    &::after {
      margin-bottom: calc((1 - ${lineHeight}) * .5em);
    }

    &::before,
    &::after {
      content: '';
      display: block;
      height: 0;
      width: 0;
    }
  `;
};

export const flexiblePercent = {
  pc: num => {
    return `${(num / 1440) * 100}%`;
  },
  sp: num => {
    return `${(num / 750) * 100}%`;
  },
};

export const dot = (dir = 'y', width = 1, margin = 3, color = black01) => {
  return `
      background-image: linear-gradient(to ${
        dir === 'y' ? 'bottom' : 'right'
      }, ${color}, ${color} ${width}px, transparent ${width}px, transparent ${width +
    margin}px);
      background-size: ${
        dir === 'y'
          ? `${width}px ${width + margin}px`
          : `${width + margin}px ${width}px`
      };
      background-repeat: ${dir === 'y' ? 'repeat-y' : 'repeat-x'};
    `;
};

export const clearfix = `
  &::after {
    display: block;
    clear: both;
    content: "";
  }
`;

export const hoverZoom = (
  durationLevel = 4,
  zoomLevel = 1.01,
  rotateLevel = 0.5
) => `
  transition: transform ${parseFloat(baseDurationTime) *
    durationLevel}s ${easeout};
  will-change: transform;
  a:hover &, a&:hover {
    transform: scale3d(${zoomLevel}, ${zoomLevel}, 1) rotate3d(0, 0, 1, ${rotateLevel}deg);
  }
`;

export const fadeAnime = keyframes`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;

export const fadeAnimeActive = css`
  animation: ${fadeAnime} ${parseFloat(baseDurationTime) * 2}s ease both;
  .is-exiting & {
    animation: none;
  }
`;

export const fadeSlideInAnime = keyframes`
  0% {
    opacity: 0;
    transform: translate3d(0, 50%, 0);
  }

  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;
export const fadeSlideInAnimeSp = keyframes`
  0% {
    opacity: 0;
    transform: translate3d(0, 40px, 0);
  }

  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;

export const fadeSlideInAnimeActive = css`
  animation: ${fadeSlideInAnime} 1s ${easeoutquart} both;
  opacity: 0;
  transform: translate3d(0, 50%, 0);
  ${mq.sp} {
    animation-name: ${fadeSlideInAnimeSp};
    transform: translate3d(0, 40px, 0);
  }
  .is-exiting & {
    animation: none;
  }
`;

export const slideDownAnime = keyframes`
  0% {
    transform: translateY(-50px);
  }
  100% {
    transform: translateY(0);
  }
`;

export const fadeSlideDownAnimeActive = css`
  animation: ${fadeAnime} 0.15s ${easeoutquart} reverse both,
    ${slideDownAnime} 1s ${easeoutquart} both;
  .is-exiting & {
    animation: none;
  }
`;

export const zoomOutAnime = keyframes`
  0% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
`;

export const zoomOutAnimeActive = css`
  animation: ${zoomOutAnime} 5s ${easeoutquart} both;
  .is-exiting & {
    animation: none;
  }
`;
